<template>
  <el-row class="create-user" v-loading="loading">
    <el-alert
      v-if="unhandledErrorMessage"
      :title="unhandledErrorMessage"
      type="error"
      @close="handleAlertClose"
    ></el-alert>
    <el-form
      ref="userCreate"
      :model="user"
      size="mini"
      label-position="left"
      label-width="10em"
      :hide-required-asterisk="true"
    >
      <el-row class="details-section role">
        <el-form-item
          :label="userFormLabels[0].label"
          :error="castErrorKeyToLang(errMessagesObject.user_type)"
        >
          <el-select
            v-model="user.user_type"
            :placeholder="userFormLabels[0].placeholder"
          >
            <template v-for="(value, key) in userRolesInPondlogs">
              <el-option
                v-if="key !== 'no_access'"
                :key="key"
                :label="$tc(value.type_name, 1)"
                :value="value.value"
              ></el-option>
            </template>
          </el-select>
          <div
            style="display: flex; align-items: center; margin-top: 6px;"
            class="role-info"
          >
            <img
              class="img-icon"
              src="@/assets/settings/exclamation-dark.svg"
            />
            <p>{{ $t(this.differentitateName[user.user_type]) }}</p>
          </div>
        </el-form-item>
      </el-row>
      <!-- <div class="user-name-element"> -->
      <el-row class="details-section">
        <div class="header">
          <img class="img-icon" src="@/assets/settings/exclamation.svg" />
          <h4>{{ $t("User_information") }}</h4>
        </div>
        <el-form-item
          prop="first_name"
          :label="userFormLabels[1].label"
          :error="castErrorKeyToLang(errMessagesObject.first_name)"
        >
          <er-input
            v-model="user.first_name"
            class="input-box"
            :placeholder="userFormLabels[1].placeholder"
          ></er-input>
        </el-form-item>
        <el-form-item
          prop="last_name"
          class="name-element"
          :label="userFormLabels[2].label"
          :error="castErrorKeyToLang(errMessagesObject.last_name)"
        >
          <er-input
            v-model="user.last_name"
            class="input-box"
            :placeholder="userFormLabels[2].placeholder"
          ></er-input>
        </el-form-item>
        <el-form-item
          prop="email"
          :label="userFormLabels[3].label"
          :error="castErrorKeyToLang(errMessagesObject.email)"
        >
          <er-input
            v-model="user.email"
            class="input-box"
            :placeholder="userFormLabels[3].placeholder"
          ></er-input>
        </el-form-item>
        <el-form-item
          prop="phone"
          :label="userFormLabels[4].label"
          :error="castErrorKeyToLang(errMessagesObject.phone)"
        >
          <er-input
            class="country-select input-box"
            v-model="user.phone"
            :placeholder="userFormLabels[4].placeholder"
            autocomplete="off"
          ></er-input>
        </el-form-item>
        <el-form-item
          prop="password"
          :label="userFormLabels[5].label"
          :error="castErrorKeyToLang(errMessagesObject.password)"
        >
          <er-input
            v-model="user.password"
            class="input-box"
            :placeholder="userFormLabels[5].placeholder"
            show-password
            autocomplete="new-password"
          ></er-input>
        </el-form-item>
        <el-form-item
          prop="confirm_password"
          :label="userFormLabels[6].label"
          :error="castErrorKeyToLang(errMessagesObject.confirm_password)"
        >
          <er-input
            v-model="user.confirm_password"
            class="input-box"
            :placeholder="userFormLabels[6].placeholder"
            @keyup.native.enter="submitForm"
            show-password
          ></er-input>
        </el-form-item>
      </el-row>
      <el-row class="details-section">
        <div class="header" v-if="user.user_type !== 'POND_OWNER'">
          <img class="img-icon" src="@/assets/settings/shield.svg" />
          <h4>{{ $t("Comn_permissions") }}</h4>
        </div>
        <pageAccessComponent
          :enableLocations="enableLocations"
          :enablePermissions="enablePermissions"
          :errorMsgLocations="errMessagesObject.allowed_locations"
          :errorMsgPermissions="errMessagesObject.permissions"
          :userType="user.user_type"
          :type="'create'"
          @selectedLocations="locations => (user.allowed_locations = locations)"
          @selectedPermissions="permissions => (user.permissions = permissions)"
        ></pageAccessComponent>
      </el-row>
      <el-row type="flex" justify="end" class="btn-action-container">
        <el-col :span="8" style="display: flex; justify-content: flex-end;">
          <er-action-button
            :type="'save'"
            :disabled="isReadOnly"
            :bgColor="'#33A02C'"
            @action-btn-click="submitForm"
          >
            <template v-slot:icon>
              <img src="@/assets/ticks.svg" />
            </template>
            <template v-slot:label>
              <p style="color: white; margin-right: 4px;">
                {{ $t("Comn_save") }}
              </p>
            </template>
          </er-action-button>
          <div style="margin-left: 8px;">
            <er-action-button
              :type="'cancel'"
              :disabled="isReadOnly"
              @action-btn-click="reload"
            >
              <template v-slot:label>
                <p style="color: black">{{ `${$t("Comn_cancel")}` }}</p>
              </template>
            </er-action-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </el-row>
</template>

<script>
import User from "@/model/user.js";
import erInput from "@/components/base/erInput.vue";
import erButton from "@/components/base/erButton.vue";
import pageAccessComponent from "@/components/settings/pageAccessComponent";

import errorHandlerMixin from "@/mixins/errorHandlerMixin.js";
import errorKeyMapMixin from "@/mixins/errorKeyMapMixin";

export default {
  mixins: [errorHandlerMixin, errorKeyMapMixin],
  components: {
    erInput,
    erButton,
    pageAccessComponent
  },
  data: function() {
    return {
      user: new User(),
      userin: "",
      loading: false,
      errMessagesObject: new User(),
      userFormLabels: [],
      differentitateName: {
        POND_WORKER: "diff_name_worker",
        POND_TECHNICIAN: "diff_name_technician",
        POND_MANAGER: "diff_name_manager",
        POND_OWNER: "diff_name_owner",
        NO_ACCESS: "diff_name_no_access"
      }
    };
  },
  computed: {
    getAdminProfile: function() {
      return this.$store.getters["user/getUserProfile"];
    },
    isReadOnly() {
      return this.$store.getters["user/isReadOnly"];
    },
    enablePermissions: function() {
      return (
        ["POND_WORKER", "POND_TECHNICIAN", "NO_ACCESS", ""].indexOf(
          this.user.user_type
        ) > -1
      );
    },
    enableLocations: function() {
      return (
        [
          "POND_WORKER",
          "POND_TECHNICIAN",
          "NO_ACCESS",
          "POND_MANAGER",
          ""
        ].indexOf(this.user.user_type) > -1
      );
    }
  },
  created: function() {
    this.userFormLabels = [
      {
        label: this.$t("Usrs_role_select"),
        placeholder: this.$t("Usrs_select_atleast_one_role")
      },
      {
        label: this.$t("Usrs_first_name"),
        placeholder: this.$t("Usrs_enter_first_name")
      },
      {
        label: this.$t("Usrs_last_name"),
        placeholder: this.$t("Usrs_enter_last_name")
      },
      {
        label: this.$t("Comn_email_address"),
        placeholder: this.$t("Usrs_enter_email_addr")
      },
      {
        label: this.$t("Comn_mobile_num"),
        placeholder: this.$t("Usrs_enter_mobile_num")
      },
      {
        label: this.$t("Usrs_pwd"),
        placeholder: this.$t("Usrs_enter_pwd")
      },
      {
        label: this.$t("Comn_confirm_pwd"),
        placeholder: this.$t("Usrs_enter_confirm_pwd")
      }
    ];
  },
  methods: {
    // handleRoleChange(evt) {
    //   console.log(evt, this.user.user_type);
    // },
    reload() {
      this.user = new User();
    },
    isLocationSet() {
      let isInitSuccess = true;

      if (
        this.user.user_type != "POND_OWNER" &&
        !this.user.allowed_locations.length > 0
      ) {
        isInitSuccess = false;
        const err = {
          type: "FAIL_TO_SAVE",
          errors: [
            {
              message: this.$t("Usrs_atlst_one_loc_msg")
            }
          ]
        };
        this.errorMessages(err, true);
      }
      return isInitSuccess;
    },
    isPermissionSet() {
      let isInitSuccess = true;

      if (
        this.user.user_type != "POND_OWNER" &&
        this.user.user_type != "POND_MANAGER" &&
        !this.user.permissions.length > 0
      ) {
        isInitSuccess = false;
        const err = {
          type: "FAIL_TO_SAVE",
          errors: [
            {
              message: this.$t("Usrs_atlst_one_permi_msg")
            }
          ]
        };
        this.errorMessages(err, true);
      }
      return isInitSuccess;
    },
    initializations() {
      let isInitSuccess = true;
      this.loading = true;

      if (this.user.user_type === "POND_OWNER") {
        delete this.user.allowed_locations;
        delete this.user.permissions;
      } else if (this.user.user_type === "POND_MANAGER") {
        delete this.user.permissions;
      }

      isInitSuccess = this.isPermissionSet();
      isInitSuccess && (isInitSuccess = this.isLocationSet());
      if (!isInitSuccess) {
        this.loading = false;
      }
      this.user.country = this.getAdminProfile.country;
      this.user.timezone = this.getAdminProfile.timezone;
      this.errMessagesObject = new User();
      return isInitSuccess;
    },
    submitForm() {
      this.initializations() &&
        this.$store
          .dispatch("user/createSubUser", this.user)
          .then(response => {
            // console.log(response)

            this.$notify({
              title: this.$t("Usrs_success_msg"),
              message: this.$t("Usrs_sub_usr_creat_succe"),
              duration: 5000,
              type: "success"
            });
            this.$emit("close", "success");
            this.reload();
          })
          .catch(err => {
            // this.errMessagesObject = new User();
            this.errorMessages(err, true);
            // this.errMessagesObject = new User();
          })
          .finally(() => {
            this.loading = false;
            this.$emit("reload");
          });
    }
  }
};
</script>

<style lang="scss">
.create-user {
  .el-select {
    width: 100%;
    .el-input__inner {
      width: 100%;
    }
  }
  .er-button {
    width: 14rem;
  }
  .details-section {
    padding-top: 20px;
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 20px;

    .el-form-item__label {
      @include responsiveProperty(
        font-size,
        $app_font_size_small,
        $app_font_size_1,
        $app_font_size_2
      );
    }
    .role-info {
      img {
        margin-right: 6px;
      }
      p {
        opacity: 0.4;
        font-weight: bold;
        line-height: 14px;
        @include responsiveProperty(
          font-size,
          $app_font_size_small,
          $app_font_size_1,
          $app_font_size_2
        );
      }
    }
  }

  .role {
    .el-form-item__label {
      color: #1f2041;
    }
  }

  .details-section:nth-of-type(1n) {
    padding-top: 0px;
  }
  // .details-section:nth-of-type(3n) {
  //   padding-bottom: 20px;
  // }
  .header {
    align-items: center;
    display: flex;
    padding-bottom: 20px;
    img {
      margin-right: 11px;
    }
  }

  .btn-action-container {
    display: flex;
    padding: 10px;
    align-items: center;
    justify-content: flex-end;

    border-top: 1px solid rgb(221, 221, 221);
    border-right: 1px solid rgb(221, 221, 221);
  }

  .el-input--mini {
    font-size: 11px !important;
    width: 279px !important;
  }
  .el-input__inner {
    text-align: left !important;
  }
}
</style>
